// Design token constants for the ApricityCare patient app.
// All values here are theme-independent (space, type, radius, shadow, status colors, border opacities).
// Theme-specific surface/text/brand colors live in src/themes/* and are merged at runtime via createTheme.
// White-label color overrides are applied in App.js render() from appContext.state.whiteLabel.colors.

export const space = {
    1:  4,
    2:  8,
    3:  12,
    4:  16,
    6:  24,
    8:  32,
    12: 48,
};

export const type = {
    display:   { fontSize: 22, fontWeight: 500, lineHeight: 1.3 },
    heading:   { fontSize: 18, fontWeight: 500, lineHeight: 1.3 },
    body:      { fontSize: 14, fontWeight: 400, lineHeight: 1.5 },
    secondary: { fontSize: 13, fontWeight: 400, lineHeight: 1.5 },
    caption:   { fontSize: 11, fontWeight: 400, lineHeight: 1.4 },
    label:     { fontSize: 11, fontWeight: 500, letterSpacing: '0.6px', textTransform: 'uppercase' },
};

export const radius = {
    sm:   6,
    md:   8,
    lg:   12,
    xl:   16,
    full: 9999,
};

// Light mode only — dark mode uses border.tertiary on cards instead of shadows.
export const shadow = {
    card:   '0 2px 8px rgba(0,0,0,0.06)',
    drawer: '0 4px 20px rgba(0,0,0,0.12)',
    modal:  '0 8px 32px rgba(0,0,0,0.16)',
};

// Opacity-based so they work on any background color.
export const border = {
    primary:   'rgba(0,0,0,0.54)',
    secondary:  'rgba(0,0,0,0.24)',
    tertiary:   'rgba(0,0,0,0.12)',
};

export const status = {
    success:        '#4CAF50',
    success_light:  '#E8F5E9',
    warning:        '#FF9800',
    warning_light:  '#FFF3E0',
    danger:         '#F44336',
    danger_light:   '#FFEBEE',
    info:           '#2196F3',
    info_light:     '#E3F2FD',
};
